<template>
    <div class="time-axis-official pb-show-display" :data-pblog="pblogData">
        <Head
            :text="officialJoined ? '官方发布' : '游戏动态'"
            :has-arrow="false"
            tab="动态"
        />
        <TimeAxisOfficialCard
            v-for="(item, idx) in officialTimeAxis.list.items"
            :key="idx"
            :official-joined="officialJoined"
            :official-news-post="item"
            :show-idx="idx"
            :game-icon="gameIcon"
            :app-name="appName"
            :show-time-axis="true"
            :follow-num-show="followNumShow"
        />
        <div
            v-if="officialTimeAxis.list.total > 2"
            class="look-more"
            @click.stop="jumpTab"
        >
            <span class="go-look-more">查看更多</span>
            <img class="arrow-right" :src="pics[0]" alt="">
        </div>
    </div>
</template>

<script>
    import Head from './app-detail-head';
    import TimeAxisOfficialCard from './app-detail-time-axis-official-card';
    import right from 'public/assets/imgs/ic_more_grey.png';
    import { eventBus } from '../../index';
    export default {
        components: {
            Head,
            TimeAxisOfficialCard
        },
        props: {
            officialJoined: {
                type: Boolean,
                required: false
            },
            officialTimeAxis: {
                type: Object,
                default: () => ({})
            },
            gameIcon: {
                type: String,
                default: ''
            },
            appName: {
                type: String,
                default: ''
            },
            followNumShow: {
                type: String,
                default: '0'
            }
        },
        data() {
            return {
                pics: [right],
                tabIndex: 0,
                moduleName: {
                    moduleName: '动态'
                },
                pblogData: {}
            }
        },
        created() {
            const tabs = this.$root.tabs;
            this.tabIndex = tabs.indexOf('动态');
            this.pblogData = JSON.stringify({
                value: 'module',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: {
                                ...this.$root.extData,
                                moduleName: '动态'
                            },
                            pos: ''
                        }
                    ]
                }
            })
            this.doDisplayLogViewMore();
        },
        methods: {
            jumpTab() {
                this.doClickViewMoreLog();
                if (this.tabIndex > 0) {
                    this.$root.tabIndex = this.tabIndex;
                }
                eventBus.$emit('toOfficialTabTop', 0);
            },
           
            doDisplayLogViewMore() {
                this.$logger.display({
                    value: 'viewMore',
                    ext: {
                        item: [
                            {
                                id: '',
                                ext: {
                                    ...this.$root.extData,
                                    moduleName: '动态'
                                },
                                pos: ''
                            }
                        ]
                    }
                });
            },
            doClickViewMoreLog(moduleName) {
                this.$logger.click({
                    value: 'viewMore',
                    ext: {
                        id: '',
                        ext: Object.assign(this.$root.extData, moduleName),
                        pos: ""
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .look-more {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: px2rem(58) 0 px2rem(62) 0;
        .go-look-more {
            font-size: px2rem(48);
            color: #858585;
            line-height: px2rem(48);
            margin-right: px2rem(18);
        }
    }
</style>